import { render, staticRenderFns } from "./FrequentVisitors.vue?vue&type=template&id=0159e118&scoped=true"
import script from "./FrequentVisitors.vue?vue&type=script&lang=js"
export * from "./FrequentVisitors.vue?vue&type=script&lang=js"
import style0 from "./FrequentVisitors.vue?vue&type=style&index=0&id=0159e118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0159e118",
  null
  
)

export default component.exports